<script>
  import {normalized_video_store} from "./Utils/stores";
  import {active_video_store} from "./Utils/stores";
  import PlaylistItem from "./PlaylistItem.svelte";
  import {onMount} from "svelte";
  import Debug from "./Utils/Debug.svelte";
  export let videos
  export let activeVideoSlug
  let activeIndex = 0;

  $:  update_active_index(videos, activeVideoSlug)

  function update_active_index(videos, activeVideoSlug) {
    activeIndex = videos.findIndex(v => v.slug.current === activeVideoSlug);
  }

  function is_active(video) {
    return video.slug.current === activeVideoSlug;
  }

</script>
<div>
  <nav aria-label="Progress" class="vec-mt-4 vec-max-h-full">
    <ol class="step-list">
        {#each videos as video, i}
          <li class="item__list_item">
            <PlaylistItem video={$normalized_video_store.videos[video.slug.current]}
                          active={is_active(video)} played={i < activeIndex}
                          last={i === videos.length -1}  on:video-clicked/>
          </li>
        {/each}
    </ol>
  </nav>
</div>
<style>

    .relative {
        position: relative;
    }

    .downline {
        width: 0.125rem;
        left: 1rem;
        top: 1rem;
        position: absolute;
        margin-left: -1px;
        margin-top: 0.125rem;
        height: 100%;
    }


    .item__list_item {
        position: relative;
        list-style: none;
        margin: 0;
        padding-bottom: 2.5rem;
    }

    .item__wrapper {
        position: relative;
        align-items: flex-start;
        display: flex;
    }

    .item__icon_wrapper {
        height: 2.25rem;
        display: flex;
        align-items: center;
    }

    .item__full_circle {
        z-index: 10;
        width: 2rem;
        position: relative;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9999px;
        background-color: black;

    }

    .item__active {
        z-index: 10;
        width: 2rem;
        position: relative;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-width: 2px;
        border-style: solid;
        border-radius: 9999px;
        border-color: black;
        background-color: white;
    }

    .item__inactive {
        z-index: 10;
        width: 2rem;
        position: relative;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-width: 2px;
        border-style: solid;
        border-radius: 9999px;
        border-color: #bebebe;
        background-color: white;
    }

    .item__tick {
        width: 1.25rem;
        height: 1.25rem;
        color: white;
    }

    .item__title_wrapper {
        min-width: 0px;
        margin-left: 1rem;
        display: flex;
        flex-direction: column;
    }

    .item__title {
        letter-spacing: 0.025em;
        text-transform: uppercase;
        font-size: 0.75rem;
        line-height: 1rem;
        font-weight: 600;
    }

    .item__active_inner {
        width: 0.625rem;
        height: 0.625rem;
        border-radius: 9999px;
        background-color: black;
    }

    .item__subtitle {
        color: #3a3a3a;
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    ol.step-list {
        overflow-y: auto;
    }

</style>
